module.exports = __webpack_public_path__ + "aw.svg?2c7ed62ea28f78e4ef20bcb229fa0766";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/aw.svg
// module id = 747
// module chunks = 27